/* "Header Tailwind" section behaviour: mobile drawer toggle + scroll-aware sticky
   background. No Liquid — kept as a static asset so sections/header.liquid stays
   small and `theme dev` incremental sync can't corrupt it.
   (Named header-section.* to avoid colliding with the unrelated base-theme header.js.) */
(function () {
  var trigger = document.querySelector('.header__menu-trigger');
  var close = document.querySelector('.header-drawer-close');
  var drawer = document.querySelector('.header-drawer');
  var overlay = document.querySelector('.header-drawer-overlay');

  var openMenu = function () {
    drawer.classList.add('is-open');
    overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
  };

  var closeMenu = function () {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
  };

  if (trigger) trigger.addEventListener('click', openMenu);
  if (close) close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);

  // Sticky header scroll-aware background
  var wrapper = document.querySelector('.header-wrapper');
  if (wrapper) {
    var threshold = 50;
    var ticking = false;
    var update = function () {
      if (window.scrollY > threshold) {
        wrapper.classList.add('is-scrolled');
      } else {
        wrapper.classList.remove('is-scrolled');
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    update();
  }
})();
